import React, { useEffect } from 'react';
import './ACVideoGallery.css';
import gallery1 from '../assets/gallery1.mp4';

// ✅ AOS imports
import AOS from 'aos';
import 'aos/dist/aos.css';

const videos = [
  {
    id: 1,
    src: gallery1,
  },
];

const ACVideoGallery = () => {

  // ✅ Initialize AOS here
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: 'ease-in-out',
      once: false, // fade in & fade out on scroll
    });
  }, []);

  return (
    <section className="ac-video-section">
      <h2
        className="video-heading"
        data-aos="fade-up"
      >
        Our Gallery
      </h2>

      <div className="video-grid">
        {videos.map(video => (
          <div
            className="video-card"
            key={video.id}
            data-aos="fade-up"
            data-aos-offset="200"
          >
            <video
              controls
              muted
              preload="metadata"
              style={{ width: '100%', borderRadius: '10px' }}
            >
              <source src={video.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ACVideoGallery;
